import { cn } from '../../../lib/cn';
import { formatHebrewRelative } from '../../../lib/relativeTime';
import { displayState, SERVICE_LABELS_HE, type BotConversationRow } from '../bot.schema';
import styles from './CapturedFieldsCard.module.css';

interface CapturedFieldsCardProps {
  conversation: BotConversationRow;
}

function Empty() {
  return <span className={cn(styles.value, styles.valueEmpty)}>—</span>;
}

export function CapturedFieldsCard({ conversation: c }: CapturedFieldsCardProps) {
  return (
    <div className={styles.card}>
      <span className={styles.title}>נתונים שנאספו</span>

      <dl className={styles.list}>
        <dt className={styles.label}>שם</dt>
        <dd className={styles.value}>{c.full_name ?? <Empty />}</dd>

        <dt className={styles.label}>סוג עסק</dt>
        <dd className={styles.value}>{c.business_type ?? <Empty />}</dd>

        <dt className={styles.label}>שירות</dt>
        <dd className={styles.value}>
          {c.service_slug ? SERVICE_LABELS_HE[c.service_slug] : <Empty />}
        </dd>

        <dt className={styles.label}>מצב</dt>
        <dd className={styles.value}>{displayState(c.state)}</dd>

        <dt className={styles.label}>דירוג</dt>
        <dd className={styles.value}>
          {c.lead_score !== null ? (
            <span className={styles.score}><span className="num">{String(c.lead_score)}</span></span>
          ) : (
            <Empty />
          )}
        </dd>

        <dt className={styles.label}>נכשל</dt>
        <dd className={styles.value}>
          <span className="num">{String(c.fallback_count)}</span>
        </dd>

        <dt className={styles.label}>נראה לאחרונה</dt>
        <dd className={styles.value}>{formatHebrewRelative(c.last_message_at)}</dd>

        <dt className={styles.label}>נפתח</dt>
        <dd className={styles.value}>{formatHebrewRelative(c.created_at)}</dd>
      </dl>

      {c.pain_text ? (
        <>
          <span className={styles.title} style={{ marginBlockStart: '8px' }}>תיאור הצורך</span>
          <p className={cn(styles.value, styles.painText)}>{c.pain_text}</p>
        </>
      ) : null}

      {c.conversation_summary ? (
        <>
          <span className={styles.title} style={{ marginBlockStart: '8px' }}>סיכום</span>
          <p className={cn(styles.value, styles.painText)}>{c.conversation_summary}</p>
        </>
      ) : null}
    </div>
  );
}
